import { VStack } from '@bpba/ui-components';
import { margin, MarginProps } from 'styled-system';
import styled from 'styled-components';
import { StyledSpan } from '../shared/StyledSpan';
import { HOME_ARTIST, HOME_DATE, HOME_SUBTITLE, HOME_TITLE, HOME_WARMUP } from '../shared/Constantes';
import { Title } from '../shared/Title';

const BaseIntro = (props: MarginProps) => {
  return (
    <VStack {...props} color={'white'} alignItems={'center'}>
      <Title title={HOME_TITLE} textAlign="center" />
      <StyledSpan fontSize={['22px', '30px']} lineHeight={['34px', '40px']} fontWeight={500}>
        <div dangerouslySetInnerHTML={{ __html: HOME_ARTIST }} />
      </StyledSpan>{' '}
      <StyledSpan fontSize={['20px', '25px']} lineHeight={['32px', '38px']} fontWeight={500}>
        <div dangerouslySetInnerHTML={{ __html: HOME_WARMUP }} />
      </StyledSpan>
      <StyledSpan fontSize={['18px', '20px']} lineHeight={['30px', '35px']} fontWeight={500}>
        <div dangerouslySetInnerHTML={{ __html: HOME_DATE }} />
      </StyledSpan>{' '}
      <StyledSpan fontSize={['18px', '20px']} lineHeight={['30px', '35px']} fontWeight={500}>
        <div dangerouslySetInnerHTML={{ __html: HOME_SUBTITLE }} />
      </StyledSpan>
    </VStack>
  );
};

export const Intro = styled(BaseIntro)<MarginProps>(margin);
